import { Suspense, useEffect } from 'react';
import { Container } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import { checkIfAdmin } from 'shared/api';
import { queryClient } from 'shared/api/tanstack';
import { Loader } from 'shared/ui/loader';
import { DashboardLeftBar } from 'widgets/dashboard-left-bar';
import styles from './dashboard-layout.module.scss';

export const DashboardLayout = () => {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    queryClient.clear();
    navigate('/auth');
  };

  const checkCurrentPath = async () => {
    try {
      const isAdmin = await checkIfAdmin();
      const path = location.pathname;
      const isAdminPath = path.includes('/admin');
      if (!isAdmin && isAdminPath) {
        navigate(path.replace('/admin', ''));
      } else {
        // if (isAdmin && !isAdminPath) {
        //   navigate(path.replace('/dashboard', '/dashboard/admin'));
        // }
      }
    } catch (e) {
      console.log(e);
      logout();
    }
  };

  useEffect(() => {
    checkCurrentPath();
  }, [window.location.href]);

  return (
    <Container
      className={styles.dashboardContainer}
      maxWidth={false}
      sx={{
        // maxWidth: '1442px',
        minHeight: '100vh',
        '&': {
          padding: '8px 16px 20px 16px',
        },
      }}
    >
      <DashboardLeftBar />
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </Container>
  );
};
